<template>
  <b-field :label="label">
    <b-autocomplete
      :value="search"
      :data="itemsFiltered"
      :loading="isFetching"
      :open-on-focus="openOnFocus"
      :disabled="disabled"
      :expanded="expanded"
      @input="getItems"
      @select="setItem"
      @click.native="$emit('click-autocomplete', $event)"
      :field="field"
      ref="queryAutocomplete"
      icon="magnify">
      <slot v-for="(_, name) in $slots" :name="name" :slot="name" />
      <template v-for="(_, name) in $scopedSlots" v-slot:[name]="data">
        <slot :name="name" v-bind="data"/>
      </template>
      <template slot="empty">
        <div v-if="!isFetching">
          {{$t('general.autocomplete.noRslt')}}
        </div>
        <div v-else>
          {{$t('general.autocomplete.search')}}
        </div>
      </template>
    </b-autocomplete>
  </b-field>
</template>

<script>
import debounce from 'lodash/debounce';
import messageErreur from '@/services/general/messageErreur';

export default {
  name: 'QueryAutocomplete',
  props: {
    label: {
      type: String,
      required: false,
    },
    value: {
      type: Object,
      required: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    filteredItemFunc: {
      type: Function,
      required: false,
    },
    openOnFocus: {
      type: Boolean,
      required: false,
      default: false,
    },
    expanded: {
      type: Boolean,
      required: false,
      default: false,
    },
    field: {
      type: String,
      required: false,
      default: 'libelle',
    },
    asyncFunc: {
      type: Function,
      required: true,
    },
    focus: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {

      items: [],
      search: null,
      isFetching: false,
    };
  },
  computed: {
    itemSelected: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      },
    },
    itemsFiltered() {
      return this.items
        .filter(el => !this.filteredItemFunc || this.filteredItemFunc(el));
    },
  },
  methods: {
    async getItemsAsync(text) {
      this.isFetching = true;
      try {
        const dataItems = await this.asyncFunc(text);
        this.items = dataItems;
      } catch (e) {
        messageErreur(this.$i18n);
        throw e;
      } finally {
        this.isFetching = false;
      }
    },
    getItems: debounce(async function itemsData(text) {
      if (text === this.search) return;
      this.search = text;
      this.itemSelected = null;
      await this.getItemsAsync(text);
    }, 500),
    setItem(val) {
      if (!val) return;
      this.search = val.libelle;
      this.itemSelected = val;
    },
  },
  async mounted() {
    if (this.value) this.search = this.value.libelle;
    if (this.openOnFocus) await this.getItemsAsync();
    if (this.focus) this.$refs.queryAutocomplete?.focus();
  },
};
</script>
